import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../Forms/BorderedFormGrid";
import { Contact } from "../Contact";
import { TextFieldInput } from "../../Forms/TextFieldInput";
import { useFetchGsdbForLocationTypes } from "../../Forms/LocationSelect/Hooks/useFetchGsdbForLocationTypes";
import { LocationTypeForContactEnum, locationTypesForContact } from "./LocationTypeForContacts";
import { LocationTypeSelect } from "../../Forms/LocationSelect/LocationTypeSelect";
import { LocationGsdbSelect } from "../../Forms/LocationSelect/LocationGsdbSelect";
import { RhfRoleMultiSelect } from "./RhfRoleMultiSelect";

export const ContactDataForm = () => {
  const {
    control,
    setValue,
    watch,
    formState: { disabled: isFormDisabled },
  } = useFormContext<Contact>();

  const [
    plantSelectionListItems,
    edcSelectionListItems,
    odcSelectionListItems,
    supplierSelectionListItems,
    branchSelectionListItems,
  ] = useFetchGsdbForLocationTypes();

  const associatedMenuItemsFor = (locationTypeId: number) => {
    switch (locationTypeId) {
      case LocationTypeForContactEnum.Plant:
        return plantSelectionListItems.data;
      case LocationTypeForContactEnum.EDC:
        return edcSelectionListItems.data;
      case LocationTypeForContactEnum.ODC:
        return odcSelectionListItems.data;
      case LocationTypeForContactEnum.CarrierBranch:
        return branchSelectionListItems.data;
      case LocationTypeForContactEnum.Supplier:
        return supplierSelectionListItems.data;
      default:
        return [];
    }
  };
  const resetSelectedGsdb = () => {
    setValue(`Location.Gsdb`, "");
  };

  return (
    <BorderedFormGrid>
      <Grid item xs={3}>
        <TextFieldInput name="LastName" control={control} label="Last Name" required />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput name="Email" control={control} label="E-Mail" required />
      </Grid>
      <Grid item xs={6}>
        <TextFieldInput name="Notes" control={control} multiline />
      </Grid>

      <Grid item xs={3}>
        <TextFieldInput name="FirstName" control={control} label="First Name" disabled />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput name="BusinessPhone" control={control} label="Business Phone" />
      </Grid>
      <Grid item xs={6}>
        <RhfRoleMultiSelect control={control} name="RoleIds" label="Roles" />
      </Grid>

      <Grid item xs={3}>
        <TextFieldInput name="JobTitle" control={control} label="Job Title" />
      </Grid>
      <Grid item xs={3}>
        <TextFieldInput name="MobilePhone" control={control} label="Mobile Phone" />
      </Grid>
      {/* Placeholder */}
      <Grid item xs={6} />
      <Grid item xs={3}>
        <LocationTypeSelect
          name="Location.Type"
          control={control}
          label="Contact Type"
          onLocationTypeChanged={() => resetSelectedGsdb()}
          locationTypes={locationTypesForContact}
          disabled={isFormDisabled}
        />
      </Grid>
      <Grid item xs={3}>
        <LocationGsdbSelect
          name="Location.Gsdb"
          control={control}
          options={associatedMenuItemsFor(watch("Location.Type"))}
          disabled={isFormDisabled}
        />
      </Grid>
    </BorderedFormGrid>
  );
};
